/* eslint-disable react-native/no-inline-styles */
import { theme } from 'aimo-ui';
import useIsDesktop from 'hooks/useIsDesktop';
import React, { useRef } from 'react';
import { Dimensions } from 'react-native';
import BottomSheet from 'react-native-simple-bottom-sheet';
import StickySheetFooter from './StickySheetFooter';

type WebSheetProps = {
  children?: React.ReactNode | (() => void);
  snappingPoints?: number[];
  showBackDrop?: boolean;
  bgColor?: string;
  stickyFooter?: JSX.Element | false;
  bottom?: boolean;
  left?: number;
  bottomInset?: boolean;
  sheetMinHeight?: number;
  sheetMaxHeight?: number;
  webSheetOpenDefault?: boolean;
  onSheetClose?: () => void;
  onSheetOpen?: () => void;
};
const Sheet: React.FC<WebSheetProps> = ({
  children,
  stickyFooter,
  bgColor,
  bottom,
  left = 30,
  sheetMaxHeight,
  sheetMinHeight,
  webSheetOpenDefault = true,
  onSheetClose,
  onSheetOpen,
}) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const panelRef = useRef<any>();
  const isDesktop = useIsDesktop();
  const { height } = Dimensions.get('window');

  const getBottomPosition = (): number => {
    if (bottom) {
      return 0;
    }
    if (isDesktop) {
      return 10;
    }
    return 0;
  };

  return (
    <BottomSheet
      ref={panelRef}
      togglePanel
      innerContentStyle={{
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        height: 11500,
        paddingHorizontal: !isDesktop ? 5 : 15,
        backgroundColor: bgColor || theme.colors.white,
      }}
      lineStyle={{ margin: 10 }}
      wrapperStyle={{
        backgroundColor: bgColor || theme.colors.white,
        top: bottom ? undefined : isDesktop ? 110 : undefined,
        left: isDesktop ? left : 0,
        width: isDesktop ? 500 : '100%',
        borderRadius: isDesktop ? 20 : 0,
        borderTopLeftRadius: 20,
        borderTopRightRadius: 20,
        paddingHorizontal: 0,
        bottom: getBottomPosition(),
      }}
      sliderMinHeight={sheetMinHeight}
      sliderMaxHeight={sheetMaxHeight ? sheetMaxHeight : height * 0.85}
      onClose={onSheetClose}
      onOpen={onSheetOpen}
      hideHandle
      isOpen={webSheetOpenDefault}>
      <>
        {typeof children === 'function' ? children() : children}
        <StickySheetFooter visible={!!stickyFooter}>
          {stickyFooter}
        </StickySheetFooter>
      </>
    </BottomSheet>
  );
};

export default Sheet;
